<template>
    <div>
        <component
            :is="wrapper"
            ref="editor"
            :value="value"
            @focus="focus"
            @blur="blur"
            v-if="!disabled"
        ></component>
        <component 
            v-else
            :is="wrapper"
            v-html="value"
            class="ck-editor-form-helper"
        ></component>
        <div v-if="error" style="color: #dc3545; border-top: 1px dotted #dc3545; margin-bottom: 15px; font-size: 10px;"><i class="fa fa-exclamation-triangle"></i> &nbsp;{{error}}</div>
    </div>
</template>
<script>
    import InlineEditor from '@ckeditor/ckeditor5-build-inline';
    export default {
        name: 'form-element-ckeditor',
        props: {
            uploadUrl:{type:String},
            wrapper:{type:String,default:'div'},
            value: "",
            csrfToken:{type:String, default: "no-token"},
            placeholder: {type: String, default: "<p></p>"},
            error: {type: String, default: null },
            minimal: {type: Boolean, default: false },
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }},
            disabled: {type: Boolean, default: false}
        },
        data: function () {
            return {
                editor: null,
                content:'',
                hasFocus:false,
            }
        },
        computed: {
            token(){return this.crsfToken || document.head.querySelector('meta[name="csrf-token"]').content;},
        },
        watch: {
            value(){
                if(!this.disabled){ this.updateContent(); }        
            }
        },
        mounted () {
            if(!this.disabled){
                InlineEditor
                    .create(this.$refs.editor, { ckfinder: { uploadUrl: this.uploadUrl, token: this.crsfToken } })
                    .then(editor => {
                        this.editor = editor;
                        this.updateContent();
                        this.content = this.value;

                        editor.model.document.on( 'change', () => {
                            this.updateValue();
                        });
                    })
                    .catch(error => {
                        console.error('CK error!',error)
                    })
            }
        },
        methods: {
            updateValue() {
                let data = this.editor.getData();
                this.content = data;
                if(this.content !== this.value && this.content!==this.placeholder)
                    this.$emit('input', data);
            },
            updateContent(){
                let value = (this.hasFocus||(this.value && this.value.length > 0))?(this.value):this.placeholder;
                if(value == null){ value = ""; }
                if(this.editor && this.content !== value)
                    this.editor.setData(value||'<p></p>');
            },
            focus(){
                this.hasFocus = true;
                this.updateContent();
            },
            blur(){
                this.hasFocus = false;
                if(this.content == "<p>&nbsp;</p>"){
                    this.editor.setData(this.placeholder);
                }
            }
        }
    }
</script>
<style scoped>
.ck {
  border: 1px solid #ced4da;
  -webkit-border-radius: 0.25rem;
  -moz-border-radius: 0.25rem;
  border-radius: 0.25rem;
}
.ck-list{
  background-color: white !important;
}
.ck-editor-form-helper img{
  max-width: 100%;
}
</style>
